<template>
  <app-layout class="nights-wizard">
    <div class="page-checkout">
      <template>
        <nights-stepper :initial-active-step="activeStep" :destination="destination" ></nights-stepper>
      </template>
    </div>

    <transition name="fade" mode="out-in" appear>
      <popup-ages
        v-if="dialogAges"
        :items="parsedPassengers"
        @submitFormEvent="setPassengersAgeEvent"
      />
    </transition>
    <snackbar-component></snackbar-component>

    <nights-mobile-booking-summary
      class="xl:hidden"
      @next="next"
    ></nights-mobile-booking-summary>
  </app-layout>
</template>

<script>
import NightsStepper from "./NightsStepper.vue";
import NightsMobileBookingSummary from "./common/NightsMobileBookingSummary.vue";
import {
  NIGHTS_FETCH_AND_SET_EXTRAS,
  NIGHTS_FETCH_AND_SET_HOTELS,
  NIGHTS_SET_DATA_FROM_QUERY_PARAMS,
  NIGHTS_FETCH_AND_SET_INITIAL_DATA,
  NIGHTS_RECHECK_HOTEL_AND_SET_FINAL_PRICE,
} from "../../store/nights/action-types";
import {
  NIGHTS_RESET_STATE,
  NIGHTS_SET_FLIGHT,
  NIGHTS_SET_HOTEL,
  NIGHTS_SET_RESOURCES,
  NIGHTS_SET_STATE,
  RESOURCES_BAGS_CALUCLATE,
} from "../../store/nights/mutation-types";
import { SET_AGE_TO_PASSENGER } from "../../store/reserve-area/mutation-types";
import { SET_STEPPER_LOADING } from "../../store/stepper/mutation-types";
import steps from "./steps";
import { goToStep } from "./mixins";
import PopupAges from "./accommodation/PopupAges.vue";
import { mapMutations, mapGetters } from "vuex";
import moment from 'moment';
import { FETCH_FLEX_EXTRAS } from "../../store/booking/action-types";
import {  NIGHTS_GET_IS_PACK_FLIGHT, NIGHTS_GET_QUERY_PARAMS } from "../../store/nights/getter-types";

export default {
  mixins: [goToStep],
  props: {
    step: {
      type: String,
      required: true,
    },
    origin: {
      type: String,
      required: true,
    },
    destination: {
      type: String,
      required: true,
    },
  },
  components: {
    NightsStepper,
    NightsMobileBookingSummary,
    PopupAges,
  },

  data() {
    return {
      activeStep: steps.indexOf(this.$route.params.step) + 1,
      previousRouteName: "",
      dialogAges: false,
    };
  },

  computed: {
    ...mapGetters({
      flightPrice: 'tripPrice',
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT
    }),
    nights(){
      return this.$store.state.nights;
    },
    showOverlay() {
      return this.$store.state.nights.showOverlay;
    },
    passengers() {
      return this.$store.state.nights.passengers;
    },
    parsedPassengers() {
      const childrenArray = this.passengers.filter((p) => p.type === "child");
      const babiesArray = this.passengers.filter((p) => p.type === "baby");

      return {
        children: [...childrenArray],
        babies: [...babiesArray],
      };
    },
    thereAreChildsOrBabys() {
      return (
        this.parsedPassengers.children.length > 0 ||
        this.parsedPassengers.babies.length > 0
      );
    },

  },

  watch: {
    $route(route) {
      this.activeStep = steps.indexOf(route.params.step) + 1;
    },
  },

  methods: {
    ...mapMutations({
      setAgeToPassenger: SET_AGE_TO_PASSENGER,
    }),
    next() {
      if (!window.show_hotelbeds) {
        let step = steps[this.activeStep];
        if (step === "alojamiento") {
          step = "extras";
        }
        if (!step) {
          this.$store.dispatch(SET_STEPPER_LOADING, true);
          this.$eventHub.$emit("nights-trying-to-pay");
        } else {
          this.goToStep(step);
        }
        return;
      }

      const step = steps[this.activeStep];
      console.log(step);
      if (!step) {
        this.$eventHub.$emit("nights-trying-to-pay");
      } else {
        this.goToStep(step);
      }
    },
    async fetchStepData(actions, next) {
      store.commit(NIGHTS_SET_STATE, ["loading", true]);
      try {
        await Promise.all(actions);
      } catch (e) {
        console.log(e);

        if (e.message === "No hotels found") {
          this.showErrorToast("toast.error_not_found_hotels");
          return this.goToStep("extras");
        }

        this.showErrorToast();

        return next(false);
      } finally {
        store.commit(NIGHTS_SET_STATE, ["loading", false]);
      }
      return next();
    },
    showErrorToast(message = null) {
      this.$toastr.e(window.i18n.t(message) || window.i18n.t("toast.error_8"));
    },
    redirectOnError() {
      if (this.previousRouteName) {
        this.$router.back();
      } else {
        this.$router.push({ name: "home-when" });
      }
    },
    showDialogAges() {
      this.dialogAges = true;
    },
    hideDialogAges() {
      this.dialogAges = false;
    },
    async setPassengersAgeEvent(passengers) {
      const { children, babies } = { ...passengers };
      const childrenAndBabies = children.concat(babies);
      this.$store.commit(NIGHTS_SET_STATE, ["loading", true]);
      this.hideDialogAges();

      childrenAndBabies.forEach(async (p) => {
        const index = this.passengers.findIndex((pass) => pass.id == p.id);
        await this.setAgeToPassenger({ index: index, passenger: p });
      });

      try {
        await store.dispatch(NIGHTS_FETCH_AND_SET_HOTELS, {});
      } catch (e) {
        console.log(e);
        this.showErrorToast(
          e.message === "No hotels found"
            ? "No se han encontrado hoteles en esta ciudad para esta distribución de pasajeros."
            : null
        );
      }
      this.$store.commit(NIGHTS_SET_STATE, ["loading", false]);
    },
    filterDiferentsHours(flights){
        // Used Hours
        let usedHours = [];
        let filteredFlights = [];

        flights.forEach(flight => {
            let originHour = moment(flight.journeyFlightDepartureTime).format('hhmm');
            let returnHour = moment(flight.returnFlightDepartureTime).format('hhmm');

            if(usedHours.every(el => el != originHour+'-'+returnHour)){
              usedHours.push(originHour+'-'+returnHour);
              filteredFlights.push(flight);
            }

        });

        return filteredFlights;
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.previousRouteName = from.name;
    });
  },

  mounted() {
    this.$nextTick(async () => {
      const route = this.$route;

      try {
        this.$store.commit(NIGHTS_SET_STATE, ["showOverlay", true]);
        this.$store.dispatch(NIGHTS_SET_DATA_FROM_QUERY_PARAMS, route.query);
        if (route.params.step !== "detalles") {
          this.goToStep("detalles");
        }
        await this.$store.dispatch(NIGHTS_FETCH_AND_SET_INITIAL_DATA, route);
        const destination =
          this.$store.state.nights.resources.destinations.find(
            ({ code }) => code === route.params.destination
          );
        if (!destination) {
          throw new Error("Destination not found");
        }
        store.commit(NIGHTS_SET_STATE, [
          "destination",
          _.cloneDeep(destination),
        ]);
        const flights = this.filterDiferentsHours(this.$store.state.nights.resources.flights)
          .filter(({ cityCodeTo }) => cityCodeTo === route.params.destination)
          .sort((a, b) => (a.price > b.price ? 1 : -1))
          .slice(0, 15);
        if (!flights.length) {
          throw new Error("No flights found for this destination");
        }
        this.$store.commit(NIGHTS_SET_RESOURCES, ["flights", flights]);
        this.$store.commit(NIGHTS_SET_FLIGHT, _.cloneDeep(flights[0]));
        const { adults, babies, children } = this.$store.getters[NIGHTS_GET_QUERY_PARAMS];
        this.$store.commit(RESOURCES_BAGS_CALUCLATE);
        if (route.query.hotel) {
          // Set hotel if a hotel code is provided in query params
          await this.$store.dispatch(NIGHTS_FETCH_AND_SET_HOTELS, {
            hotelCode: route.query.hotel,
          });
          this.$store.commit(
            NIGHTS_SET_HOTEL,
            this.$store.state.nights.resources.hotels[0]
          );
          await this.$store.dispatch(NIGHTS_RECHECK_HOTEL_AND_SET_FINAL_PRICE);
          this.$store.commit(NIGHTS_SET_STATE, ["hotelSetFromCode", true]);
          this.goToStep("extras");
        }
      } catch (e) {
        console.log(e);
        this.showErrorToast();
        // this.redirectOnError();
      } finally {
        this.$store.commit(NIGHTS_SET_STATE, ["showOverlay", false]);
      }
    });
  },

  async beforeRouteUpdate(to, from, next) {
    this.$store.commit(NIGHTS_SET_STATE, ["loading", false]);

    const step = to.params.step;
    if(!this.isPackFlight){
      if (step === "alojamiento") {
        if (this.thereAreChildsOrBabys) {
          this.showDialogAges();
          return next();
        }

        return !this.$store.state.nights.resources.hotels.length
          ? this.fetchStepData(
              [store.dispatch(NIGHTS_FETCH_AND_SET_HOTELS, {})],
              next
            )
          : next();
      }
    }
    if (step === "extras") {
      return this.fetchStepData(
        [
          store.dispatch(FETCH_FLEX_EXTRAS, this.flightPrice),
          store.dispatch(NIGHTS_FETCH_AND_SET_EXTRAS, {code: this.nights.destination.code, airlines: this.nights.flight.airlines}),
        ],
        next
      );
    }

    next();
  },

  beforeRouteLeave(to, from, next) {
    if (!["nights-destinations", "nights-confirmation"].includes(to.name)) {
      this.$store.commit(NIGHTS_RESET_STATE);
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";

.nights-wizard::v-deep {
  h1 {
    color: black;
    font-size: 28px !important;
    text-align: left;
    font-weight: bold;

    @media (min-width: 1024px) {
      font-size: 26px !important;
    }
  }

  .outline-btn {
    background-color: white !important;
    color: $turquoiseBlue !important;
    border-color: $turquoiseBlue !important;
    border: 2px solid $turquoiseBlue !important;
    span {
      font-weight: bold;
    }
  }

  .v-snack__content {
    text-align: center !important;
  }

  .loading-overlay {
    z-index: 2001;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
